import { DEFAULT_PROPS } from './constants';

export const calculateOffset = (
  currentPage: number = DEFAULT_PROPS.currentPage,
  itemsPerPage: number = DEFAULT_PROPS.itemsPerPage
): number => currentPage * itemsPerPage;

export const calculatePageFromOffsetLimit = (offset: number, limit: number): number =>
  offset / limit;

export const convertPageParamsForApi = (itemsPerPage: number, page: number) => ({
  limit: itemsPerPage,
  offset: calculateOffset(page, itemsPerPage),
});
